import type { ADFEntity } from '@atlaskit/adf-utils/types';

const ATLAS_DOC_FORMAT = 'atlas_doc_format';

type DynamicBody = { value?: string | null; representation?: string | null } | null | undefined;

type ContentNodeWithBody = {
	body?: { dynamic?: DynamicBody } | null;
} | null;

export type ParseableContentNodes = ReadonlyArray<ContentNodeWithBody> | null | undefined;

const parsedAdfByContentNodes = new WeakMap<object, ADFEntity | null>();

export const parseContentNodesAdf = (contentNodes: ParseableContentNodes): ADFEntity | null => {
	if (!contentNodes || !contentNodes[0]) {
		return null;
	}

	if (parsedAdfByContentNodes.has(contentNodes)) {
		return parsedAdfByContentNodes.get(contentNodes) ?? null;
	}

	const dynamicBody = contentNodes[0].body?.dynamic;
	let parsedAdf: ADFEntity | null = null;
	if (dynamicBody?.value && dynamicBody.representation === ATLAS_DOC_FORMAT) {
		try {
			parsedAdf = JSON.parse(dynamicBody.value) as ADFEntity;
		} catch {
			parsedAdf = null;
		}
	}

	parsedAdfByContentNodes.set(contentNodes, parsedAdf);
	return parsedAdf;
};
